import axios from 'axios'

export default {
    login: (data) => axios.post('login', data),
    loginWithAdmin: (access_token, account_id) => axios.post('login-with-admin', {access_token: access_token, account_id: account_id}),
    loginPartner: (access_token) => axios.post('login-partner', {access_token: access_token}),
    loginOwner: (access_token, account_id) => axios.post('login-owner', {access_token: access_token, account_id: account_id}),
    validate: (data) => axios.post('login/validate', data),
    validateRFC: (rfc) => axios.post('validate-rfc', {rfc: rfc}),
    validateEmail: (email) => axios.post('validate-email', {email: email}),
    getUser: (id) => axios.post('get-user', {id: id}),
    activateAccount: (data) => axios.post('account/activate', data),
    recoveryAccount: (data) => axios.post('account/send-recover-password-link', data),
    recoveryPassword: (data) => axios.post('account/recover-password', data),
    storeAccount: (data) => axios.post('account/store', data),
    storeOwnerAccount: (data) => axios.post('account/owner-store', data),
}